import { createContext, useContext, useState } from "react";

// Crear el contexto
const PendingOrdersContext = createContext();

// Hook personalizado para usar el contexto
export const usePendingOrders = () => useContext(PendingOrdersContext);

// Proveedor del contexto
export const PendingOrdersProvider = ({ children }) => {
  const [pendingOrdersCount, setPendingOrdersCount] = useState(0);

  return (
    <PendingOrdersContext.Provider
      value={{ pendingOrdersCount, setPendingOrdersCount }}
    >
      {children}
    </PendingOrdersContext.Provider>
  );
};
